// List of all the acction types within the app
// used so you dont mess up the string
export enum ActionType {
	SET_EXAMPLE = 'set_example',
	UNDO = 'undo',
	REDO = 'redo',
	IMPORT_FILES = 'import_files',
	ADD_AUDIO_FILE = 'add_audio_file',
	AUDIO_FILE_LOADED = 'audio_file_loaded',
	DELETE_AUDIO_FILE = 'delete_audio_file',
	PLAY_AUDIO_FILE = 'play_audio_file',
	PLAY_TIMELINE = 'play_timeline',
	EXPORT_TIMELINE = 'export_timeline',
	SET_TIMELINE_TIME = 'set_timeline_time', // Manually set timeline time
	UPDATE_TIMELINE_TIME = 'update_timeline_time', // Timeline time updated because it's currently playing
	STOP_PLAYBACK = 'stop_playback',
	INSERT_AUDIO_CLIP = 'insert_audio_clip',
	DELETE_AUDIO_CLIP = 'delete_audio_clip',
	SELECT_AUDIO_CLIP = 'select_audio_clip',
	SET_STAGE_SHAPE = 'set_stage_shape',
	SET_STAGE_SIZE = 'set_stage_size',
	SET_UNITS = 'set_units',
	ADD_SET_PIECE = 'add_set_piece',
	SET_SET_PIECE_RECT = 'set_set_piece_rect',
	SET_AUDIENCE_POS_ROTATION = 'set_audience_pos_rotation',
	SET_SELECTED_SET_PIECE = 'set_selected_set_piece',
	SET_SELECTED_DANCER = 'set_selected_dancer',
	UPDATE_SET_PIECE_NAME = 'update_set_piece_name',
	UPDATE_SET_PIECE_APPEARANCE = 'update_set_piece_appearance',
	DELETE_SET_PIECE = 'delete_set_piece',
	UPDATE_FILTER = 'update_filter',
	SET_TRACK_MUTED = 'set_track_muted',
	SET_ALL_TRACKS_MUTED = 'set_all_tracks_muted',
	MOVE_AUDIO_CLIP = 'move_audio_clip',
	SAVE_PROJECT = 'save_project',
	ACTIVATE_PROJECT = 'activate_project',
	LOAD_PROJECT = 'load_project',
	SET_CURRENT_STATE = 'set_current_state',
	RESET_STATE = 'reset_state',
	ADD_DANCER_PATH_NODE = 'add_dancer_path_node',
	SET_DANCER_PATH_NODE = 'set_dancer_path_node',
	SET_DANCER_PATH_NODE_DURATION = 'set_dancer_path_node_duration',
	DELETE_DANCER_PATH_NODE = 'delete_dancer_path_node',
	MOVE_FUTURE_DANCER_PATH_NODE = 'move_future_dancer_path_node',
	ADD_DANCER = 'add_dancer',
	DELETE_DANCER = 'delete_dancer',
	SET_DANCER_NAME = 'set_dancer_name',
	SET_DANCER_PATH_APPEARANCE = 'set_dancer_path_appearance',
	SET_DANCER_HEIGHT = 'set_dancer_height',
	SET_ACOUSTIC_SETTINGS_PRESET = 'set_acoustic_settings_preset',
	SET_CUSTOM_ACOUSTIC_SETTINGS = 'set_custom_accoustic_settings',
	SELECT_DANCER_PATH_NODE = 'select_dancer_path_node',
	DELETE_AUDIO_CLIPS_AT_TIME = 'delete_audio_clips_at_time',
	SELECT_AUDIO_GAP = 'select_audio_gap',
	DELETE_AUDIO_GAP = 'delete_audio_gap',
	SET_SHORTCUTS_ENABLED = 'set_shortcuts_enabled',
}
